import React from "react"
import { Link } from "gatsby"
import Layout from "../../components/Layout"
import Pagetitle from "../../components/Pagetitle"
import Seo from "../../components/Seo"
import RelatedPlatforms from "../../components/RelatedPlatforms"
import { PLATFORM_GUIDE_OG_IMAGE } from "../../data/platforms"

const SnapchatPage = () => (
  <Layout>
    <Seo
      title="Adding your feed to Snapchat Dynamic Ads"
      description="Step-by-step instructions for adding your Upfeed product feed to Snapchat Ads Manager to run Dynamic Product Ads."
      image={PLATFORM_GUIDE_OG_IMAGE}
    />
    <div className="container">
      <div className="row justify-content-center">
        <div className="getting-started col-md-8">
          <Link to="/getting-started/#platforms" className="back-link">
            ← All platforms
          </Link>
          <Pagetitle>Adding your feed to Snapchat Dynamic Ads</Pagetitle>
          <p>
            Follow these steps to connect your UpFeed product feed to Snapchat
            Ads Manager so you can run Dynamic Product Ads to reach Snapchat's
            audience.
          </p>

          <div className="prerequisites">
            <p>Before you start, make sure you have:</p>
            <ul>
              <li>
                <Link to="/getting-started/#generate">
                  Generated your product feed
                </Link>{" "}
                and copied the feed URL from the app homepage.
              </li>
              <li>A Snapchat Business account with Ads Manager access.</li>
            </ul>
          </div>

          <h2>Setting up your Snapchat product catalog</h2>
          <ul>
            <li>
              Log in to{" "}
              <a href="https://ads.snapchat.com" target="_blank" rel="noreferrer">
                Snapchat Ads Manager
              </a>{" "}
              and click the menu icon in the top left.
            </li>
            <li>Navigate to 'Catalogs' under the Assets section.</li>
            <li>
              Click 'Create Catalog', enter a catalog name, and select your
              business.
            </li>
            <li>
              Click 'Add Product Feed' and choose 'Scheduled Feed' as the input
              method.
            </li>
            <li>Paste your product feed URL from the app.</li>
            <li>
              Select 'CSV' as the feed format and set the refresh schedule to
              'Daily'.
            </li>
            <li>Click 'Save' and wait for Snapchat to process your feed.</li>
          </ul>

          <h2>Running Dynamic Product Ads</h2>
          <p>
            Once your catalog is live, create a new campaign in Snapchat Ads
            Manager and choose 'Dynamic Ads' as the objective. Select your
            product catalog, set up your audience targeting and budget, and
            launch your campaign.
          </p>

          <RelatedPlatforms currentSlug="snapchat" />
        </div>
      </div>
    </div>
  </Layout>
)

export default SnapchatPage
